import { ButtonHTMLAttributes, FC } from 'react';

import styles from './EditButton.module.scss';

interface Props {
  label: string;
  onClick?: ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
  size?: number;
  testId?: string;
}

const EditButton: FC<Props> = ({ onClick = () => null, label, testId = '' }) => (
  <button className={styles.button} data-test-id={testId} onClick={onClick} type="button">
    <img src="/static/images/icons/Icon_Edit.svg" alt="" />
    {label}
  </button>
);

export default EditButton;
export type { Props as EditButtonProps };
